import { jsx as r, jsxs as p } from "react/jsx-runtime";
import { getDefaultImageByProductType as s } from "../utils/get-default-image-by-type.mjs";
import f from "../../../components/card-wrapper.mjs";
import c from "../../../components/item-thumbnail-base.mjs";
import d from "../../../ui-kit/theme-button.mjs";
const y = ({
  productType: o,
  thumbnail: t,
  buttonTitle: i,
  subTitle: m,
  title: a,
  checkoutPage: e,
  headingLevel: n
}) => {
  const l = () => {
    e.path && window.location.assign(e.path);
  };
  return /* @__PURE__ */ r(f, { children: /* @__PURE__ */ p("div", { className: "flex flex-col gap-3", children: [
    /* @__PURE__ */ r(
      c,
      {
        title: a,
        subTitle: m,
        imageType: s(o),
        thumbnail: t,
        headingLevel: n
      }
    ),
    /* @__PURE__ */ r(d, { onClick: l, children: i })
  ] }) });
};
export {
  y as default
};
